import React from 'react'
import { Box } from "@mui/material"

import { useCardsInfo } from "Pages/Main/Home/@hooks"
import { AppAnalyticsCard } from "@components"


export default function SearchAnalyticsHomeCards() {

	const { data, isLoading } = useCardsInfo()
	const { todaySearches, weekSearches, monthSearches } = data

	const datesList = [
		{
			label: "Today:",
			actual: todaySearches,
			icon: "calendar-range",
			iconColor: "colors.green"
		},
		{
			label: "This Week:",
			actual: weekSearches,
			icon: "calendar-week",
			iconColor: "colors.blue"
		},
		{
			label: "This Month:",
			actual: monthSearches,
			icon: "calendar-days",
			iconColor: "colors.red"
		}
	]

	return <Box
		data-tour-id="tour-activity-cards"
		sx={{
			display: "flex",
			alignItems: "stretch",
			flexDirection: "column",
			p: 0,
			gap: 2,
			height: '100%'
		}}>
		{datesList.map(({ label, actual, icon, iconColor }, idx) => {
			return <AppAnalyticsCard key={idx} icon={icon} iconColor={iconColor} isLoading={isLoading} label={label} countUp={actual}/>
		})}
	</Box>
}